var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home mt-8 mt-md-16"},[(_vm.site == 'creators')?_c('CreatorsHome'):_c('StandardHome')],1)}
var staticRenderFns = []

export { render, staticRenderFns }